import { render, staticRenderFns } from "./TopRecognisersTable.vue?vue&type=template&id=354f4cad&scoped=true&"
import script from "./TopRecognisersTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./TopRecognisersTable.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./TopRecognisersTable.vue?vue&type=style&index=0&id=354f4cad&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354f4cad",
  null
  
)

export default component.exports